<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 139.91 195.2">
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8" d="M114.55 49l13.54-23.46a14.34 14.34 0 10-24.83-14.34L89.72 34.64a66 66 0 00-82 84.76l25-43.32h0a43 43 0 1115.74 58.79L62.78 110a14.34 14.34 0 10-5.24-19.59l-45.73 79.27A14.34 14.34 0 1036.64 184l13.54-23.46A66 66 0 00114.55 49z" data-name="Layer 1"/>
    </svg>
</template>
